import { useNavigate } from 'react-router-dom'
import { useContext } from 'react'

import { AnalyticsEvent } from 'src/types'
import { useLocales } from 'src/contexts'

import { useAppSelector } from 'src/hooks/useAppSelector'
import { useAppDispatch } from 'src/hooks/useAppDispatch'
import { useIsMobile } from 'src/hooks/use-mobile'
import { AnalyticsContext } from 'src/contexts/AnalyticsContext'

import { logout } from 'src/store/thunks/authThunk'
import { queryClient } from 'src/features/AppProviders/constants'

export const useNavUser = () => {
  const { translations } = useLocales()
  const isMobile = useIsMobile()
  const { user } = useAppSelector(state => state.auth)
  const { logEvent } = useContext(AnalyticsContext)

  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const handleLogout = (): void => {
    dispatch(logout(navigate))

    logEvent(AnalyticsEvent.LOGOUT)
    localStorage.clear()
    queryClient.clear()
  }

  return {
    locale: translations,
    isMobile,
    userName: user?.displayName || '',
    mail: user?.email || '',
    photoURL: user?.photoURL || '',
    handleLogout,
  }
}
